module.exports = __webpack_public_path__ + "img/zztbg-5.bb495998.png";